import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiReviewTileProduct } from '@/fo/ui/review/tile/product';
import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './SuccessMessage.styles';

export interface SuccessMessageProps {
  type: 'review' | 'question';
  onClick?: () => void;
  products?: MappedProduct[];
}

export function SuccessMessage({
  type,
  products,
  onClick
}: SuccessMessageProps) {
  const slots = styles();

  const t = useTranslations('review.form.success');

  const title = type === 'review' ? t('title') : t('questionTitle');

  const description =
    type === 'review' ? t('description') : t('questionDescription');

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{title}</h2>
      <p className={slots.description()}>{description}</p>
      <UiKitButtonBase
        className={slots.button()}
        onClick={onClick}
      >
        {t('button')}
      </UiKitButtonBase>

      {products && products.length > 0 && (
        <div className={slots.products()}>
          <h3 className={slots.productsTitle()}>{t('products')}</h3>
          <div className={slots.productsList()}>
            {products.map((product) => (
              <UiReviewTileProduct
                key={product.sku}
                title={`${product.series} ${product.name}`.trim()}
                imageUrl={product.thumbnail?.src}
                tags={product.volume ? [product.volume] : []}
                url={product.link}
                color="secondary"
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
